/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Polkadot_Chain_Tps_ExplanationInputs */



/**
* | output |
* | --- |
* | "ParachainSystem, ParaInherent, Timestamp, and Lighthouse" |
*
* @param {Polkadot_Chain_Tps_ExplanationInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const polkadot_chain_tps_explanation = /** @type {((inputs?: Polkadot_Chain_Tps_ExplanationInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Polkadot_Chain_Tps_ExplanationInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("ParachainSystem, ParaInherent, Timestamp, and Lighthouse")
});